// Listen for clicks on the product tile grid
// and display the info as a pseudo hover
import { toggleClass } from '../helpers';

window.addEventListener('touchstart', function() {
	document.body.classList.add('js-has-touch');
});


const init = () => {
	const productTiles = document.querySelectorAll('.product-tile-container');

	if (!productTiles) {
		return;
	}

	function toggleOverlay(e) {
		if (
			e.target.classList.contains('product-tile__image-column') ||
			e.target.classList.contains('product-tile__info-column') ||
			e.target.classList.contains('product-tile__image')
		) {
			toggleClass(e.target.closest('.product-tile'), '-overlay-active');
		}
	}

	productTiles.forEach(tile => {
		tile.addEventListener('click', toggleOverlay, true);
	});
};

if ('ontouchstart' in document.documentElement) {
	init();
}
